import VueSmartGrid from './components/'
export default VueSmartGrid



// WEBPACK FOOTER //
// ./src/package.js